export enum LastValidationStatus {
  APPROVED_AUTOMATIC = 'APROVACAO_AUTOMATICA',
  APPROVED_MANUAL = 'APROVACAO_MANUAL',
  REJECTED_MANUAL = 'REJEICAO_MANUAL',
}
